import React from 'react';
import PropTypes from 'prop-types';
import { Link, Routes, Route } from 'react-router-dom';

// Third-parties.
import Helmet from 'react-helmet';

// User Settings Views.
import ChangePassword from './ChangePassword';
import Breadcrumb from "../../container/breadcrumb";
import PeriodBreadcrumb from "../../component/PeriodBreadcrumb";
import HeaderActions from "../../container/header_actions";
import ConditionalRender from "../../helpers/ConditionalRender";
import NotFound from "../NotFound";

function UserSettings(props: {
    toggleMenu: Function,
    applyPeriod: Function,
    loginRequired: boolean
}) {

    return (
            <Routes>
                <Route path="/" element={
                    <React.Fragment>
                        <div id="content">
                            <Helmet>
                                <title>User Settings - DBmarlin</title>
                                <meta name="description" content="User settings and preferences within DBmarlin"/>
                            </Helmet>

                            <div id="top-header-wrapper" className="row row-cols-lg-3 row-cols-sm-1 row-cols-md-2">
                                <Breadcrumb heading="User Settings">
                                    <Link to="/user-settings">User Settings</Link>
                                    <PeriodBreadcrumb/>
                                </Breadcrumb>
                                <HeaderActions toggleMenu={props.toggleMenu} refresh={() => {
                                }}/>
                            </div>

                            <div className="loader">
                                <ConditionalRender if={false}>
                                    <div className="bar"></div>
                                </ConditionalRender>
                            </div>

                            <div className="row row-cols-1">
                                <div className="col h-100">
                                    <div className="card">
                                        <div className="card-header">
                                            <i className="fal fa-user-cog fa-fw" aria-hidden="true"/>
                                            User Settings
                                            <i className="collapse-toggle" role="button" data-bs-toggle="collapse"
                                               data-bs-target="#collapseUserSettings" aria-expanded="false"
                                               aria-controls="collapseUserSettings"/>
                                        </div>
                                        <div id="collapseUserSettings" className="card-body collapse show">
                                            <p>Please select an option from below:</p>
                                            <ul>
                                                <ConditionalRender if={props.loginRequired}>
                                                    <li><Link to="/user-settings/change-password">Change Password</Link></li>
                                                </ConditionalRender>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </React.Fragment>
                }/>
                <Route path="/change-password/*"
                       element={<ChangePassword toggleMenu={props.toggleMenu} applyPeriod={props.applyPeriod}/>}/>

                <Route path="*" element={<NotFound/>}/>
            </Routes>
    );
}

UserSettings.propTypes = {
    toggleMenu: PropTypes.func.isRequired,
    applyPeriod: PropTypes.func.isRequired
};

export default UserSettings;